import { useState } from "react";
import MUIDataTable from "mui-datatables";
import "../Tabla.css";
import ModalModificarRecuperacion from "./ModalModificarRecuperacion";
import DialogoConfirmacionRecuperacion from "./DialogoConfirmacionRecuperacion";

const TablaRecuperacion = ({ datosTabla }) => {
  const [itemClicked, setItemClicked] = useState(undefined);

  const columns = [
    {
      name: "codigo",
      label: "Código",
      options: {
        filter: false,
        display: true,
      },
    },
    {
      name: "nombre",
      label: "Nombre",
      options: {
        filter: false,
        display: true,
      },
    },
    {
      name: "ambito",
      label: "Ámbito",
      options: {
        filter: false,
        display: true,
      },
    },

    {
      name: "id",
      label: " ",
      options: {
        filter: false,
        display: true,
        sort: false,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => (
          <DialogoConfirmacionRecuperacion id={value} />
        ),
      },
    },
  ];

  const options = {
    expandableRowsOnClick: true,
    filterType: "dropdown",
    onPageChange: true,
    responsive: "standard",
    download: false,
    tableBodyHeight: "estándar",
    tableBodyMaxHeight: "estándar",
    onRowsPerPageChange: 10,
    print: false,
    viewColumns: true,
    filter: false,
    selectableRows: "none",
    onRowClick: (e, meta) => {
      handleOpenModal(meta.dataIndex);
    },

    textLabels: {
      body: {
        noMatch: "Registros no encontrados",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Registros por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        viewColumns: "Ver columnas",
        downloadCsv: "Descargar",
      },
      download: {},

      viewColumns: {
        title: "Mostrar columnas",
        titleAria: "Mostrar/Esconder columnas",
      },
    },
  };

  const handleOpenModal = (index) => {
    setItemClicked(datosTabla[index]);
  };

  const handleDeleteItemClicked = () => {
    setItemClicked(undefined);
  };

  return (
    <div>
      <MUIDataTable data={datosTabla} columns={columns} options={options} />

      {itemClicked && (
        <ModalModificarRecuperacion
          onHide={handleDeleteItemClicked}
          ambito={itemClicked.ambito}
          ambitoInicial={itemClicked.ambitoInicial}
          nombre={itemClicked.nombre}
          id={itemClicked.id}
          codigo={itemClicked.codigo}
        />
      )}
    </div>
  );
};

export default TablaRecuperacion;
